function getCookie(name) {
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  let arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

function setCookie(name, value, time) {
  if (time) {
    let strsec = getsec(time);
    let exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie =
      name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  } else {
    document.cookie = name + "=" + escape(value);
  }
}

function delCookie(name) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
}

function getsec(str) {
  let str1 = str.substring(1, str.length) * 1;
  let str2 = str.substring(0, 1);
  if (str2 == "s") {
    return str1 * 1000;
  } else if (str2 == "h") {
    return str1 * 60 * 60 * 1000;
  } else if (str2 == "d") {
    return str1 * 24 * 60 * 60 * 1000;
  }
}

function getType(data) {
  const toString = Object.prototype.toString;
  const map = {
    "[object Boolean]": "Boolean",
    "[object Number]": "Number",
    "[object String]": "String",
    "[object Function]": "Function",
    "[object Array]": "Array",
    "[object Date]": "Date",
    "[object RegExp]": "RegExp",
    "[object Undefined]": "Undefined",
    "[object Null]": "Null",
    "[object Object]": "Object"
  };
  return map[toString.call(data)];
}

function isType(type) {
  return function(content) {
    let t = getType(content);
    return t === type;
  };
}

function deepCopy(data) {
  const t = getType(data);
  let o;
  if (t === "Array") {
    o = [];
    for (let i = 0; i < data.length; i++) {
      o.push(deepCopy(data[i]));
    }
  } else if (t === "Object") {
    o = {};
    for (let i in data) {
      o[i] = deepCopy(data[i]);
    }
  } else {
    return data;
  }
  return o;
}

function changeToTwoDimensionalArray(list, num) {
  let arr = [];
  let minArr = [];
  list.forEach(data => {
    if (minArr.length === num) {
      minArr = [];
    }
    if (minArr.length === 0) {
      arr.push(minArr);
    }
    minArr.push(data);
  });
  return arr;
}
function arrayTransTree(list, key) {
  let data = deepCopy(list);
  let tree = data.filter(function(parent) {
    let branchArr = data.filter(function(child) {
      return parent.ID === child[key] || parent.id === child[key];
    });
    if (branchArr.length > 0) {
      parent.children = branchArr;
    }
    return parent[key] === "0" || !parent[key];
  });
  return tree;
}
function deepTree(tree, key, value) {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i][key] === value) {
      return tree[i];
    } else if (tree[i].children != null && tree[i].children.length > 0) {
      deepTree(tree[i].children, key, value);
    }
  }
}
function array2Tree(list, key) {
  let nodes = [];
  let nodemp = new Map();
  list.forEach(item => {
    nodemp.set(item.ID, item);
  });

  list.forEach(item => {
    let pidx = item[key];
    let prt = nodemp.get(pidx);
    if (prt) {
      if (!prt.children) prt.children = [];
      prt.children.push(item);
    } else {
      nodes.push(item);
    }
  });
  return nodes;

}
export default {
  deepCopy,
  getCookie,
  deepTree,
  setCookie,
  array2Tree,
  delCookie,
  changeToTwoDimensionalArray,
  getType,
  isType,
  arrayTransTree,
  isString: isType("String"),
  isNumber: isType("Number"),
  isFunction: isType("Function"),
  isUndefined: isType("Undefined"),
  isBoolean: isType("Boolean"),
  isArray: isType("Array")
};
